export const CLEAR_EXTRACT = "clearExtract";
export const SET_EXTRACT = "setExtract";
export const SET_RESUME = "setResume";
export const SET_QUERY_PARAMS = "setQueryParams";
